<template>
  <main class="profile-page page">
    <div class="container-padding">
      <div class="profile-page__inner">
        <div class="profile-page__content">
          <ProfileCardComponent
            :title="user.name + ' ' + (user.surname || '')"
            :phone="user.phone"
            :email="user.email"
            icon="edit"
          />
          <ProfileCardComponent
            title="История заказов"
            :subtitle="orders.length | plural('заказ', 'заказа', 'заказов')"
            icon="cart"
            :route="{ name: 'orders' }"
          />
          <ProfileCardComponent
            title="Избранное"
            :subtitle="favorites.length | plural('товар', 'товара', 'товаров')"
            icon="heart"
            :route="{ name: 'favourite' }"
          />
        </div>
        <ProfileAsideComponent />
      </div>
    </div>
  </main>
</template>

<script>
import ProfileCardComponent from "./components/ProfileCardComponent.vue";
import ProfileAsideComponent from "./components/ProfileAsideComponent.vue";

export default {
  name: "ProfilePage",
  components: {
    ProfileAsideComponent,
    ProfileCardComponent,
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    favorites() {
      return this.$store.state.auth.favoritesItems;
    },
    orders() {
      return this.$store.state.auth.orders;
    },
  },
  mounted() {
    console.log(this.$store.state.auth);
  },
};
</script>

<style lang="stylus">
.profile-page {

  &__inner {
    display grid
    grid-template-columns 2fr 1fr
    grid-gap 30px
    +below(1200px) {
      grid-template-columns 1fr
    }
  }

  &__content {
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-auto-rows 1fr
    grid-gap 30px
    +below(750px) {
      grid-template-columns 1fr
    }
    +below(600px) {
      grid-auto-rows 385px 200px 200px
    }
  }
}
</style>
